import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// MUI Components
import { useTheme } from '@mui/material/styles';
import { Box, Paper, IconButton, TextField, Chip, Checkbox } from '@mui/material';
import { Table, TableHead, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import FilteredAssetsFetcher from './FilteredAssetsFetcher'

// MUI Icons
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import DetailsIcon from '@mui/icons-material/Details';
import ClearIcon from '@mui/icons-material/Clear';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Tooltip from '@mui/material/Tooltip';


// API Queries
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import { useGetofficesQuery } from '../../../features/offices/officesApiSlice';
import { useGetAssetsFinalFilteredQuery, useLazyGetAssetsFinalFilteredQuery } from '../../../features/addassets/addassetfinalApiSlice';
import { useGetStoreOfficesQuery } from '../../../features/storeoffices/storeofficesApiSlice';

// Styles
import { TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import styled from 'styled-components';

// Utilities
import ExcelDownload from '../../../data/exceldownload';
import dayjs from 'dayjs';
import moment from 'moment';

// Components
import MyAssetDetailModal from './MyAssetDetailModal';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Button2Div = styled.div`
  display: flex;
  justify-content: end;
`;

const Wrapper = styled.div`
  display: flex;
  background-color: white;
  align-items: center;
`;

const SpanContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
`;

const StatusSpan = styled.span`
  font-size: 16px;
  font-family: Arial, sans-serif;
  font-weight: bold;
  color: #333;
`;

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

// Responsive font size function
const getTableFontSize = (breakpoint) => ({
  xs: 11,
  sm: 12,
  md: 13,
  lg: 14
});

// Common ellipsis style for table cells
const ellipsisStyle = {
  fontSize: getTableFontSize(),
  padding: { xs: '8px 4px', sm: '16px 8px' },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

// Debounce function
function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
}

export default function UnivMyAssetComp({
  keyArrayDwld,
  columnFilter,
  checkbox,
  selectedOptions,
  setSelectedOptions,
  selectAll,
  filterProps
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [assetdetailmodalopen, setAssetDetailmodalopen] = useState(false);
  const [assetdetailModaldata, setAssetDetailModaldata] = useState({});
  const [downloadData, setDownloadData] = useState({});
  const [allData, setAllData] = useState([]);
  const [filters, setFilters] = useState({
    name: "",
    oem_tag:  "",
    org_tag:  "",
    model_no:  "",
    oem:  "",
    cur_user_name:  "",
    specification: "",
    cur_store: [], 
    alloc_ofc: [], 
    alloc_user: [],
    ids: [],
    cur_loc:[],
    from_purchase_date:  "",
    to_purchase_date:  "",
    from_installation_date:  "",
    to_installation_date:  "",
    from_warrantyexp_date:  "",
    to_warrantyexp_date:  "",
    perm_cur_store:[],
    perm_alloc_ofc:[],
    perm_alloc_user:[],
    perm_ids:[],
    perm_cur_loc:[],
    perm_name:[],
    perm_notname:[],
    perm_specification:[],
    in_transit:"",
    indi_issue:[]
  });

  // Regular paginated query for displaying data
  const { data: finalData, isLoading } = useGetAssetsFinalFilteredQuery({
    page: page + 1, // Convert MUI's 0-based index to 1-based API pagination
    limit: rowsPerPage,
    filters, // Add any filter conditions here
  });
  
  useEffect(() => {
    if (filterProps) {
      for(let key in filters) {
        if (filterProps[key]) {
          setFilters((prevFilters) => ({
            ...prevFilters,
            [key]: filterProps[key],
          }));
        }
      }
    }
  }, [filterProps]);


  const { users } = useGetUsersQuery("UserList", {
    selectFromResult: ({ data }) => ({
      users: data?.entities,
    }),
  });

  const { storeoffice } = useGetStoreOfficesQuery('storeoffice', {
    selectFromResult: ({ data }) => ({
      storeoffice: data?.entities,
    }),
  });

  const { offices } = useGetofficesQuery("OffList", {
    selectFromResult: ({ data }) => ({
      offices: data?.entities,
    }),
  });

  const [tabledata, setTabledata] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const handleAssetDetailModalClose = () => {
    setAssetDetailmodalopen(false);
  };

  const handleDetailsClick = (e, row) => {
    setAssetDetailModaldata(row);
    setAssetDetailmodalopen(true);
  };

  const handleCheckboxChange = (event, row) => {
    if (event.target.checked) {
      setSelectedOptions([...selectedOptions, row]);
    } else {
      setSelectedOptions(selectedOptions.filter((selectedId) => selectedId?.id !== row?.id));
    }
  };

  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      // Select all Objects
      setSelectedOptions(allData?.assets);
    } else {
      // Deselect all
      setSelectedOptions([]);
    }
  };
// console.log(selectedOptions)
  const handleSearchChange = debounce((event, newValue, name) => {
    let value;

    if (name) {
      // If a date is selected, check if it's valid and convert to ISO format
      if (  newValue?.$d ) {
        value = newValue?.toDate().toISOString(); // Convert to ISO format
      } else {
        value = newValue; // Reset if invalid date
      }
    } else {
      // Handle non-date input fields
      name = event.target.name;
      value = event.target.value;
    }
  
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  }, 500);

  useEffect(() => {
    if (finalData) {
      setTabledata(finalData?.assets);
    }
  }, [finalData]);

  // Prepare download data when API data is available
  useEffect(() => {
    if (allData?.assets && keyArrayDwld) {
      console.log(allData?.assets)
      const tempDownloadData = structuredClone(allData?.assets || []);
      const finalDownloadData = tempDownloadData.map(({ _id, ...others }) => ({
        ...others,
        specification: Object.entries(others?.specification)
          .map((x) => ` ${x[0]}: ${x[1]}`)
          .join(","),
        last_trans_date: moment(others?.last_trans_date).format("DD/MM/YYYY"),
      }));

      const finalSortedDownloadData = finalDownloadData.map((value) =>
        keyArrayDwld.reduce((acc, key) => ({ ...acc, [key]: value[key] }), {})
      );

      setDownloadData(finalSortedDownloadData);
    }
  }, [allData, keyArrayDwld]);

  return (
    <>
      <FilteredAssetsFetcher filters={filters} onDataFetched={setAllData} />

      {(allData?.assets && keyArrayDwld) && (
        <Button2Div>
          <ExcelDownload data={downloadData} filename={"assetDetail"} sheetName={"sheet1"} />
        </Button2Div>
      )}
      <div style={{ 
        width: '100%', 
        padding: '8px',
        boxSizing: 'border-box'
      }}>
        {(selectedOptions?.length)? (
          <SpanContainer>
            <StatusSpan style={{ 
              fontSize: { xs: '14px', sm: '16px' }
            }}>
              {`Total Items Selected: ${selectedOptions.length} (${Object.entries(
                selectedOptions.reduce((acc, { name }) => {
                  acc[name] = (acc[name] || 0) + 1;
                  return acc;
                }, {})
              )
                .map(([name, count]) => `${name}: ${count}`)
                .join(', ')})`}
            </StatusSpan>
          </SpanContainer>
        ): null}
        <TableContainer 
          component={Paper} 
          sx={{ 
            backgroundColor: TableContStyle.backgroundColor,
            width: '100%',
            margin: { xs: '8px 0', sm: '16px 0' },
            boxShadow: { xs: 1, sm: 3 }
          }}
        >
          <Table 
            sx={{ 
              width: '100%',
              tableLayout: 'fixed' // This ensures columns respect width constraints
            }} 
            aria-label="custom pagination table"
          >
            <TableHead style={{ 
              backgroundColor: TableHeadStyle.backgroundColor,
              position: 'sticky',
              top: 0,
              zIndex: 1
            }}>
              <TableRow>               
                {(checkbox || selectAll) && <TableCell sx={{ 
                  width: "5%",
                  maxWidth: "5%"
                }}>
                  {selectAll ? (
                    <Checkbox name={`select-all`} onChange={handleSelectAllChange} />
                  ):null}
                </TableCell>}
                <TableCell style={TableHeadStyle} sx={{ 
                  width: "5%",
                  maxWidth: "5%"
                }}>
                  Sl.No.
                </TableCell>
                <TableCell style={TableHeadStyle} sx={{ 
                  width: "10%",
                  maxWidth: "10%"
                }} align="left">
                  Asset
                </TableCell>
                {columnFilter?.includes("OEM/ORG Tag") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "12%",
                    maxWidth: "12%"
                  }} align="left">
                    OEM/ORG Tag
                  </TableCell>
                )}
                {columnFilter?.includes("OEM/Brand") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "10%",
                    maxWidth: "10%"
                  }} align="left">
                    OEM/Brand
                  </TableCell>
                )}
                {columnFilter?.includes("Model") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "10%",
                    maxWidth: "10%"
                  }} align="left">
                    Model
                  </TableCell>
                )}
                {columnFilter?.includes("Specification") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "12%",
                    maxWidth: "12%"
                  }} align="left">
                    Specification
                  </TableCell>
                )}
                {columnFilter?.includes("Indi_Issue") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "8%",
                    maxWidth: "8%"
                  }} align="left">
                    Indi_Issue
                  </TableCell>
                )}
                {/* {columnFilter?.includes("Specification") && (
                  <TableCell style={TableHeadStyle} sx={{ width: { md: "11%" } }} align="left">
                    Specs
                  </TableCell>
                )} */}
                {columnFilter?.includes("User") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "12%",
                    maxWidth: "12%"
                  }} align="left">
                    User
                  </TableCell>
                )}
                {columnFilter?.includes("Store") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "10%",
                    maxWidth: "10%"
                  }} align="left">
                    Store
                  </TableCell>
                )}
                {columnFilter?.includes("Alloc_Office") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "14%",
                    maxWidth: "14%"
                  }} align="left">
                    Alloc_Office
                  </TableCell>
                )}
                {columnFilter?.includes("Loc_Type") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "8%",
                    maxWidth: "8%"
                  }} align="left">
                    Loc_Type
                  </TableCell>
                )}
                {columnFilter?.includes("Purchase Date") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "10%",
                    maxWidth: "10%"
                  }} align="left">
                    Purchase Date
                  </TableCell>
                )}
                {columnFilter?.includes("Warranty Date") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "10%",
                    maxWidth: "10%"
                  }} align="left">
                    Warranty Date
                  </TableCell>
                )}
                {columnFilter?.includes("Detail") && (
                  <TableCell style={TableHeadStyle} sx={{ 
                    width: "6%",
                    maxWidth: "6%"
                  }} align="left">
                    Detail
                  </TableCell>
                )}
              </TableRow>

              <TableRow>
                {(checkbox || selectAll) && <TableCell></TableCell>}
                <TableCell></TableCell>
                <TableCell>
                  <TextField
                    sx={{ 
                      background: "white",
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '12px', sm: '14px' },
                        padding: { xs: '8px', sm: '10px' }
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: { xs: '12px', sm: '14px' }
                      }
                    }}
                    name="name"
                    onChange={handleSearchChange}
                    label="Search Asset"
                    size="small"
                    variant="outlined"
                    fullWidth
                  />
                </TableCell>
                {columnFilter?.includes("OEM/ORG Tag") && (
                  <TableCell>
                    <TextField
                      sx={{ 
                        background: "white",
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' },
                          padding: { xs: '8px', sm: '10px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      name="oem_tag"
                      onChange={handleSearchChange}
                      label="Search OEM/ORG Tag"
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  </TableCell>
                )}
                {columnFilter?.includes("OEM/Brand") && (
                  <TableCell>
                    <TextField
                      sx={{ 
                        background: "white",
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' },
                          padding: { xs: '8px', sm: '10px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      name="oem"
                      onChange={handleSearchChange}
                      label="OEM/Brand"
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  </TableCell>
                )}
                {columnFilter?.includes("Model") && (
                  <TableCell>
                    <TextField
                      sx={{ 
                        background: "white",
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' },
                          padding: { xs: '8px', sm: '10px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      name="model_no"
                      onChange={handleSearchChange}
                      label="Model"
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  </TableCell>
                )}
                {columnFilter?.includes("Specification") && (
                  <TableCell>
                    <TextField
                      sx={{ 
                        background: "white",
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' },
                          padding: { xs: '8px', sm: '10px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      name="specification"
                      onChange={handleSearchChange}
                      label="Search Specification"
                      placeholder="e.g. i7, 16GB, 1TB"
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  </TableCell>
                )}
                {columnFilter?.includes("Indi_Issue") && (
                  <TableCell>
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      onChange={(event, newValue) => handleSearchChange(event, newValue, "indi_issue")}
                      size="small"
                      value={filters?.indi_issue || []}
                      options={["true", "false"]}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option === "true" ? "Yes" : "No"}
                      ListboxProps={{
                        style: {
                          maxHeight: '200px',
                          fontSize: '12px'
                        }
                      }}
                      componentsProps={{
                        popper: {
                          modifiers: [
                            {
                              name: 'flip',
                              enabled: false,
                            },
                            {
                              name: 'preventOverflow',
                              enabled: true,
                              options: {
                                altAxis: true,
                                altBoundary: true,
                                tether: true,
                                rootBoundary: 'document',
                              },
                            },
                          ],
                        },
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ 
                          fontSize: "12px",
                          padding: "4px 8px",
                          lineHeight: "1.2",
                          minHeight: "32px",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ 
                              marginRight: "4px", 
                              marginLeft: "0",
                              padding: "2px"
                            }}
                            checked={selected}
                            size="small"
                          />
                          <span style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1
                          }} title={option === "true" ? "Yes" : "No"}>
                            {option === "true" ? "Yes" : "No"}
                          </span>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          label="Search Indi Issue" 
                          sx={{ 
                            background: "white", 
                            width: "100%",
                            '& .MuiInputBase-input': {
                              fontSize: { xs: '11px', sm: '12px' },
                              padding: { xs: '6px', sm: '8px' }
                            },
                            '& .MuiInputLabel-root': {
                              fontSize: { xs: '11px', sm: '12px' }
                            },
                            '& .MuiChip-root': {
                              fontSize: '10px',
                              height: '20px'
                            }
                          }} 
                        />
                      )}
                    />
                  </TableCell>
                )}
                {/* {columnFilter?.includes("Specification") && (
                  <TableCell>
                    <TextField
                      sx={{ background: "white" }}
                      name="specification"
                      onChange={handleSearchChange}
                      label="Specs"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                )} */}
                {columnFilter?.includes("User") && (
                  <TableCell>
                    <TextField
                      sx={{ 
                        background: "white",
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' },
                          padding: { xs: '8px', sm: '10px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      name="cur_user_name"
                      onChange={handleSearchChange}
                      label="User"
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  </TableCell>
                )}
                {columnFilter?.includes("Store") && (
                  <TableCell>
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      onChange={(event, newValue) => handleSearchChange(event, newValue, "cur_store")}
                      size="small"
                      value={filters?.store}
                      options={storeoffice ? Object.values(storeoffice).map((x) => x.storeoffice) : []}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option}
                      ListboxProps={{
                        style: {
                          maxHeight: '200px',
                          fontSize: '12px'
                        }
                      }}
                      componentsProps={{
                        popper: {
                          modifiers: [
                            {
                              name: 'flip',
                              enabled: false,
                            },
                            {
                              name: 'preventOverflow',
                              enabled: true,
                              options: {
                                altAxis: true,
                                altBoundary: true,
                                tether: true,
                                rootBoundary: 'document',
                              },
                            },
                          ],
                        },
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ 
                          fontSize: "12px",
                          padding: "4px 8px",
                          lineHeight: "1.2",
                          minHeight: "32px",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ 
                              marginRight: "4px", 
                              marginLeft: "0",
                              padding: "2px"
                            }}
                            checked={selected}
                            size="small"
                          />
                          <span style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1
                          }} title={option}>
                            {option}
                          </span>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          label="Search Store" 
                          sx={{ 
                            background: "white", 
                            width: "100%",
                            '& .MuiInputBase-input': {
                              fontSize: { xs: '11px', sm: '12px' },
                              padding: { xs: '6px', sm: '8px' }
                            },
                            '& .MuiInputLabel-root': {
                              fontSize: { xs: '11px', sm: '12px' }
                            },
                            '& .MuiChip-root': {
                              fontSize: '10px',
                              height: '20px'
                            }
                          }} 
                        />
                      )}
                    />
                  </TableCell>
                )}
                {columnFilter?.includes("Alloc_Office") && (
                  <TableCell>
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      onChange={(event, newValue) => handleSearchChange(event, newValue, "alloc_ofc")}
                      size="small"
                      value={filters?.alloc_ofc}
                      options={offices ? ["Not Applicable"].concat(Object.values(offices).map((x) => x.name).sort()) : []}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option}
                      ListboxProps={{
                        style: {
                          maxHeight: '200px',
                          fontSize: '12px'
                        }
                      }}
                      componentsProps={{
                        popper: {
                          modifiers: [
                            {
                              name: 'flip',
                              enabled: false,
                            },
                            {
                              name: 'preventOverflow',
                              enabled: true,
                              options: {
                                altAxis: true,
                                altBoundary: true,
                                tether: true,
                                rootBoundary: 'document',
                              },
                            },
                          ],
                        },
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ 
                          fontSize: "12px",
                          padding: "4px 8px",
                          lineHeight: "1.2",
                          minHeight: "32px",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ 
                              marginRight: "4px", 
                              marginLeft: "0",
                              padding: "2px"
                            }}
                            checked={selected}
                            size="small"
                          />
                          <span style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1
                          }} title={option}>
                            {option}
                          </span>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          label="Search Offices" 
                          sx={{ 
                            background: "white", 
                            width: "100%",
                            '& .MuiInputBase-input': {
                              fontSize: { xs: '11px', sm: '12px' },
                              padding: { xs: '6px', sm: '8px' }
                            },
                            '& .MuiInputLabel-root': {
                              fontSize: { xs: '11px', sm: '12px' }
                            },
                            '& .MuiChip-root': {
                              fontSize: '10px',
                              height: '20px'
                            }
                          }} 
                        />
                      )}
                    />
                  </TableCell>
                )}
                {columnFilter?.includes("Loc_Type") && (
                  <TableCell>
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      onChange={(event, newValue) => handleSearchChange(event, newValue, "cur_loc")}
                      size="small"
                      value={filters?.cur_loc}
                      options={["user", "office", "store"]}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option}
                      ListboxProps={{
                        style: {
                          maxHeight: '200px',
                          fontSize: '12px'
                        }
                      }}
                      componentsProps={{
                        popper: {
                          modifiers: [
                            {
                              name: 'flip',
                              enabled: false,
                            },
                            {
                              name: 'preventOverflow',
                              enabled: true,
                              options: {
                                altAxis: true,
                                altBoundary: true,
                                tether: true,
                                rootBoundary: 'document',
                              },
                            },
                          ],
                        },
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ 
                          fontSize: "12px",
                          padding: "4px 8px",
                          lineHeight: "1.2",
                          minHeight: "32px",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ 
                              marginRight: "4px", 
                              marginLeft: "0",
                              padding: "2px"
                            }}
                            checked={selected}
                            size="small"
                          />
                          <span style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1
                          }} title={option}>
                            {option}
                          </span>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          label="Search Loc" 
                          sx={{ 
                            background: "white", 
                            width: "100%",
                            '& .MuiInputBase-input': {
                              fontSize: { xs: '11px', sm: '12px' },
                              padding: { xs: '6px', sm: '8px' }
                            },
                            '& .MuiInputLabel-root': {
                              fontSize: { xs: '11px', sm: '12px' }
                            },
                            '& .MuiChip-root': {
                              fontSize: '10px',
                              height: '20px'
                            }
                          }} 
                        />
                      )}
                    />
                  </TableCell>
                )}
                {columnFilter?.includes("Purchase Date") && (
                  <TableCell>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker", "DatePicker"]} sx={{ margin: "0px", display: "flex" }}>
                        <Wrapper>
                          <DatePicker
                            label="From"
                            maxDate={filters?.to_purchase_date ? dayjs(filters.to_purchase_date) : null}
                            slotProps={{ textField: { size: "small" } }}
                            sx={{ backgroundColor: "white" }}
                            value={filters?.from_purchase_date ? dayjs(filters.from_purchase_date) : null}
                            format="DD/MM/YYYY"
                            onChange={(newValue) => handleSearchChange(null, newValue, "from_purchase_date")}
                          />
                          {filters?.from_purchase_date && (
                            <ClearIcon onClick={() => handleSearchChange(null, null, "from_purchase_date")} />
                          )}
                        </Wrapper>
                      </DemoContainer>
                    </LocalizationProvider>
                    {filters?.from_purchase_date && (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker", "DatePicker"]}>
                          <Wrapper>
                            <DatePicker
                              label="To"
                              minDate={filters?.from_purchase_date ? dayjs(filters.from_purchase_date) : null}
                              slotProps={{ textField: { size: "small" } }}
                              sx={{ backgroundColor: "white" }}
                              value={filters?.to_purchase_date ? dayjs(filters.to_purchase_date) : null}
                              format="DD/MM/YYYY"
                              onChange={(newValue) => handleSearchChange(null, newValue, "to_purchase_date")}
                            />
                            {filters?.to_purchase_date && (
                              <ClearIcon onClick={() => handleSearchChange(null, null, "to_purchase_date")} />
                            )}
                          </Wrapper>
                        </DemoContainer>
                      </LocalizationProvider>
                    )}
                  </TableCell>
                )}
                {columnFilter?.includes("Warranty Date") && (
                  <TableCell>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker", "DatePicker"]}>
                        <Wrapper>
                          <DatePicker
                            label="From"
                            maxDate={filters?.to_warrantyexp_date ? dayjs(filters.to_warrantyexp_date) : null}
                            slotProps={{ textField: { size: "small" } }}
                            sx={{ backgroundColor: "white" }}
                            value={filters?.from_warrantyexp_date ? dayjs(filters.from_warrantyexp_date) : null}
                            format="DD/MM/YYYY"
                            onChange={(newValue) => handleSearchChange(null, newValue, "from_warrantyexp_date")}
                          />
                          {filters?.from_warrantyexp_date && (
                            <ClearIcon onClick={() => handleSearchChange(null, null, "from_warrantyexp_date")} />
                          )}
                        </Wrapper>
                      </DemoContainer>
                    </LocalizationProvider>
                    {filters?.from_warrantyexp_date && (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker", "DatePicker"]}>
                          <Wrapper>
                            <DatePicker
                              label="To"
                              minDate={filters?.from_warrantyexp_date ? dayjs(filters.from_warrantyexp_date) : null}
                              slotProps={{ textField: { size: "small" } }}
                              sx={{ backgroundColor: "white" }}
                              value={filters?.to_warrantyexp_date ? dayjs(filters.to_warrantyexp_date) : null}
                              format="DD/MM/YYYY"
                              onChange={(newValue) => handleSearchChange(null, newValue, "to_warrantyexp_date")}
                            />
                            {filters?.to_warrantyexp_date && (
                              <ClearIcon onClick={() => handleSearchChange(null, null, "to_warrantyexp_date")} />
                            )}
                          </Wrapper>
                        </DemoContainer>
                      </LocalizationProvider>
                    )}
                  </TableCell>
                )}
                {columnFilter?.includes("Detail") && <TableCell></TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {tabledata?.length > 0 &&
                tabledata.slice(0, rowsPerPage).map((row, index) => (
                  <TableRow key={index}>
                    {(checkbox || selectAll) && (
                      <TableCell>
                        <Tooltip
                          title={
                            checkbox === undefined && selectAll
                              ? "Please Select All Assets"
                              : ""
                          }
                          arrow
                        >
                          <span> {/* Wrapping span needed to avoid Tooltip error on disabled elements */}
                            <Checkbox
                              name={`select-${row.id}`}
                              checked={selectedOptions.map(x => x?.id)?.includes(row?.id)}
                              onChange={(event) => handleCheckboxChange(event, row)}
                              disabled={checkbox === undefined && selectAll}
                            />
                          </span>
                        </Tooltip>
                      </TableCell>
                    )}
                    <TableCell component="th" scope="row" align="center" sx={{
                      ...ellipsisStyle,
                      textAlign: 'center'
                    }}>
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell align="left" sx={ellipsisStyle} title={row?.name}>
                      {row?.name}
                    </TableCell>
                    {columnFilter?.includes("OEM/ORG Tag") && (
                      <TableCell 
                        align="left" 
                        sx={ellipsisStyle}
                        title={row?.org_tag?.length ? `${row?.oem_tag} / ${row?.org_tag}` : row?.oem_tag}
                      >
                        {row?.org_tag?.length ? `${row?.oem_tag} / ${row?.org_tag}` : row?.oem_tag}
                      </TableCell>
                    )}
                    {columnFilter?.includes("OEM/Brand") && (
                      <TableCell align="left" sx={ellipsisStyle} title={row?.oem}>
                        {row?.oem}
                      </TableCell>
                    )}
                    {columnFilter?.includes("Model") && (
                      <TableCell align="left" sx={ellipsisStyle} title={row?.model_no}>
                        {row?.model_no}
                      </TableCell>
                    )}
                    {columnFilter?.includes("Specification") && (
                      <TableCell 
                        align="left" 
                        sx={ellipsisStyle} 
                        title={
                          row?.specification 
                            ? Object.entries(row.specification)
                                .map(([key, value]) => `${key}: ${value}`)
                                .join(', ')
                            : ''
                        }
                      >
                        {row?.specification 
                          ? Object.entries(row.specification)
                              .map(([key, value]) => `${key}: ${value}`)
                              .join(', ')
                          : ''
                        }
                      </TableCell>
                    )}
                    {columnFilter?.includes("Indi_Issue") && (
                      <TableCell align="left" sx={ellipsisStyle} title={row?.indi_issue ? "Yes" : "No"}>
                        {row?.indi_issue ? "Yes" : "No"}
                      </TableCell>
                    )}
                    {/* {columnFilter.includes("Specification") && (
                      <TableCell align="left" sx={{ fontSize: tableFontSize }}>
                        {Object.entries(row?.specification).map((elm, ind) => (
                          <Chip sx={{ margin: "2px" }} key={ind} label={`${elm[0]}: ${elm[1]}`} />
                        ))}
                      </TableCell>
                    )} */}
                    {columnFilter?.includes("User") && (
                      <TableCell align="left" sx={ellipsisStyle} title={row?.cur_user_name}>
                        {row?.cur_user_name}
                      </TableCell>
                    )}
                    {columnFilter?.includes("Store") && (
                      <TableCell align="left" sx={ellipsisStyle} title={row?.cur_store}>
                        {row?.cur_store}
                      </TableCell>
                    )}
                    {columnFilter?.includes("Alloc_Office") && (
                      <TableCell align="left" sx={ellipsisStyle} title={row?.alloc_ofc}>
                        {row?.alloc_ofc}
                      </TableCell>
                    )}
                    {columnFilter?.includes("Loc_Type") && (
                      <TableCell align="left" sx={ellipsisStyle} title={row?.cur_loc}>
                        {row?.cur_loc}
                      </TableCell>
                    )}
                    {columnFilter?.includes("Purchase Date") && (
                      <TableCell 
                        align="left" 
                        sx={ellipsisStyle}
                        title={moment(row?.purchase_date).format("DD-MM-YYYY")}
                      >
                        {moment(row?.purchase_date).format("DD-MM-YYYY")}
                      </TableCell>
                    )}
                    {columnFilter?.includes("Warranty Date") && (
                      <TableCell 
                        align="left" 
                        sx={ellipsisStyle}
                        title={moment(row?.warrantyexp_date).format("DD-MM-YYYY")}
                      >
                        {moment(row?.warrantyexp_date).format("DD-MM-YYYY")}
                      </TableCell>
                    )}
                    {columnFilter?.includes("Detail") && (
                      <TableCell align="center" sx={{
                        ...ellipsisStyle,
                        textAlign: 'center'
                      }}>
                        <DetailsIcon
                          sx={{ 
                            color: "green", 
                            fontSize: { xs: "20px", sm: "24px", md: "28px" }, 
                            "&:hover": { cursor: "pointer" } 
                          }}
                          onClick={(e) => handleDetailsClick(e, row)}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 100, 500, 1000]}
                  colSpan={3}
                  count={finalData?.totalFilteredAssets || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { "aria-label": "rows per page" },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  sx={{
                    '.MuiTablePagination-toolbar': {
                      fontSize: { xs: '12px', sm: '14px' },
                      minHeight: { xs: '40px', sm: '52px' }
                    },
                    '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                      fontSize: { xs: '12px', sm: '14px' }
                    }
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>

      {assetdetailmodalopen && (
        <MyAssetDetailModal
          assetdetailmodalopen={assetdetailmodalopen}
          assetdetailModaldata={assetdetailModaldata}
          handleAssetDetailModalClose={handleAssetDetailModalClose}
          users={users}
        />
      )}
    </>
  );
}